import { Bank } from '../../../models/bank.model';

/**
 * Mock data for bank entities used in testing and development
 */
export const mockBanks: Bank[] = [
  {
    routingNumber: '021000021',
    bankName: 'JPMorgan Chase Bank',
    city: 'New York',
    state: 'NY',
  },
  {
    routingNumber: '011401533',
    bankName: 'PNC Bank',
    city: 'Pittsburgh',
    state: 'PA',
  },
  {
    routingNumber: '121000248',
    bankName: 'Wells Fargo Bank',
    city: 'San Francisco',
    state: 'CA',
  },
  {
    routingNumber: '111000025',
    bankName: 'Bank of America',
    city: 'Charlotte',
    state: 'NC',
  },
  {
    routingNumber: '063100277',
    bankName: 'BB&T Bank',
    city: 'Winston-Salem',
    state: 'NC',
  },
  {
    routingNumber: '122235821',
    bankName: 'Silicon Valley Bank',
    city: 'Santa Clara',
    state: 'CA',
  },
  {
    routingNumber: '124003116',
    bankName: 'Citibank',
    city: 'New York',
    state: 'NY',
  },
  {
    routingNumber: '071923909',
    bankName: 'U.S. Bank',
    city: 'Minneapolis',
    state: 'MN',
  },
];

/**
 * Record for fast lookup of banks by routing number
 */
export const mockBanksByRoutingNumber: Record<string, Bank> = mockBanks.reduce((acc, bank) => {
  acc[bank.routingNumber] = bank;
  return acc;
}, {} as Record<string, Bank>);
